import React from "react";
import { useEffect, useRef } from "react";
import c from "classnames";

const lineCount = 3;

export default function AudioPulse({ active, volume, hover }) {
  const lines = useRef([]);

  useEffect(() => {
    let timeout = null;
    const update = () => {
      lines.current.forEach(
        (line, i) =>
          (line.style.height = `${Math.min(
            24,
            4 + volume * (i === 1 ? 400 : 60),
          )}px`),
      );
      timeout = window.setTimeout(update, 100);
    };

    update();

    return () => clearTimeout(timeout);
  }, [volume]);

  return (
    <div className={c("flex w-6 justify-evenly items-center transition-all duration-500 h-1 transition-opacity duration-300", {
      "opacity-100": active,
      "hover:animate-hover": hover
    })}>
      {Array(lineCount)
        .fill(null)
        .map((_, i) => (
          <div
            key={i}
            ref={(el) => (lines.current[i] = el)}
            style={{ animationDelay: `${i * 133}ms` }}
            className={c("bg-neutral-30 rounded-full w-1 min-h-1 transition-height duration-100", {
              "bg-neutral-80": active
            })}
          />
        ))}
    </div>
  );
} 